export default __webpack_public_path__ + "static/media/default.e234591f.jpg";